import styled, { css } from "styled-components";

import { BRAND, WHITE } from "../colors";
import componentSizes from "../constants/componentSizes";
import { Caps } from "../typography";

const imageDimensions = {
  [componentSizes.XS]: css`
    height: 32px;
    width: 32px;
  `,
  [componentSizes.SM]: css`
    height: 72px;
    width: 72px;
  `,
  [componentSizes.MD]: css`
    height: 96px;
    width: 96px;
  `,
  [componentSizes.LG]: css`
    height: 128px;
    width: 128px;
  `
};

const labelDimensions = {
  [componentSizes.XS]: "",
  [componentSizes.SM]: css`
    font-size: 12px;
    line-height: 16px;
    width: 30px;
  `,
  [componentSizes.MD]: css`
    font-size: 14px;
    line-height: 20px;
    width: 40px;
  `,
  [componentSizes.LG]: css`
    font-size: 16px;
    line-height: 24px;
    width: 48px;
  `
};

const dimensions = dimensionsObject => ({ size }) => dimensionsObject[size];

export const Container = styled.span`
  display: flex;
  height: max-content;
  justify-content: center;
  position: relative;

  * {
    box-sizing: border-box;
  }
`;

const BaseImg = styled.img`
  border-radius: 50%;
  display: block;
  object-fit: cover;
  ${dimensions(imageDimensions)}
`;

export const DefaultImg = styled(BaseImg)`
  border: 2px solid ${WHITE};
`;

export const AvatarImg = styled(BaseImg)``;

export const ProLabel = styled(Caps)`
  background-color: ${BRAND};
  bottom: 0;
  color: ${WHITE};
  left: 50%;
  position: absolute;
  text-align: center;
  transform: translate(-50%, 35%);
  ${dimensions(labelDimensions)}
`;
